import React from "react";
import { Link } from "gatsby";
import { OutboundLink } from "gatsby-plugin-google-gtag";

function Footer() {
  return (
    <footer className="bg-[#050615] text-white pb-12 md:pb-16 mt-16">
      <div className="mx-auto max-w-[1200px] px-6 lg:px-2">
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-6 gap-2">
          {/* Column 1: OHIF Title */}
          <div>
            <h4 className="text-[18px] md:text-[20px] leading-[32px] md:leading-[32px] font-normal">
              Open Health
              <br />
              Imaging Foundation
            </h4>
          </div>

          {/* Column 2: Internal Links */}
          <div className="lg:ml-8">
            <ul className="space-y-0.5">
              <FooterLink href="/roadmap">Roadmap</FooterLink>
              <FooterLink href="/team">Team</FooterLink>
              <FooterLink
                href="https://github.com/OHIF/Viewers/blob/master/LICENSE"
                isInternal={false}
              >
                License
              </FooterLink>
              <FooterLink href="/release-notes">Release Notes</FooterLink>
            </ul>
          </div>

          {/* Column 3: External Links */}
          <div>
            <ul className="space-y-0.5">
              <FooterLink href="/get-support">
                <span className="leading-tight">Support & Collaborate</span>
              </FooterLink>
              <FooterLink
                href="https://github.com/OHIF/Viewers"
                isInternal={false}
              >
                GitHub
              </FooterLink>
              <FooterLink
                href="https://join.slack.com/t/cornerstonejs/shared_invite/zt-3108kuc8m-ON1zP3nWsrgPNv9mM0E5fw"
                isInternal={false}
              >
                Slack Group
              </FooterLink>
              <FooterLink
                href="https://community.ohif.org/"
                isInternal={false}
              >
                Discussions
              </FooterLink>
              <FooterLink
                href="https://www.linkedin.com/company/ohif"
                isInternal={false}
              >
                LinkedIn
              </FooterLink>
            </ul>
          </div>

          {/* Column 4: MGH Logo + License */}
          <div className="md:col-span-3 lg:col-span-3 md:pt-8 lg:pt-0 lg:pl-24">
            {/* MGH Logo */}
            <div className="mb-6">
              <OutboundLink
                href="https://www.massgeneral.org"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src="/images/mgh-logo-white.svg"
                  alt="Massachusetts General Hospital - Founding Member, Mass General Brigham"
                  className="h-[33px] w-[317px] hover:opacity-75 transition-opacity"
                />
              </OutboundLink>
            </div>

            <p className="text-[15px] leading-[22px] text-white/50">
              OHIF is open source software released under the{' '}
              <OutboundLink
                href="https://github.com/OHIF/Viewers/blob/master/LICENSE"
                target="_blank"
                rel="noreferrer"
                className="border-b border-white/50 hover:border-white/70 hover:text-white/70"
              >
                MIT license
              </OutboundLink>
              .
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}

function FooterLink({ isInternal = true, href, children }) {
  const linkClasses = "text-[#358cfd] text-[16px] leading-[31px] hover:text-white transition-colors";

  if (isInternal) {
    return (
      <li>
        <Link className={linkClasses} to={href}>
          {children}
        </Link>
      </li>
    );
  } else {
    return (
      <li>
        <OutboundLink
          href={href}
          target="_blank"
          rel="noreferrer"
          className={linkClasses}
        >
          {children}
        </OutboundLink>
      </li>
    );
  }
}

export default Footer;
